import React from "react";
import classNames from "classnames";
import BatchDialerlogo from "assets/images/BatchDialerlogo.svg";
import tickdisable from "assets/images/tickdisableicon.svg";
import greentick from "assets/images/greentick.svg";
import menuicon from "assets/images/menu-dots-icon.svg";
import menuhover from "assets/images/menu-dots-hover.svg";
import css from "../style.scss";
import PopoverMenu from "../../components/BatchdailerMenu/PopoverMenu";
import RemoveBatchDialer from "../modals/RemoveBatchDialer";
import BatchDialer from "../modals/BatchDialer";
import { selectUserId } from "data/user/selectors";
import { useDispatch, useSelector } from "react-redux";
import { getBatchDialerIntegration, getTeamMembers } from "data/user/actions";
import { selectBatchDialerList, selectTeamMembers } from "data/user/selectors";
import TeamsBatchDailer from "../modals/TeamsBatchDailer";


const BatchDialerSection = React.forwardRef(({ isOpen: propIsOpen, onClose, onSelect, onClick, index }, ref) => {

  const [text, setText] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const [modalType, setModalType] = React.useState(null);
  const [showCopyMsg, setShowCopyMsg] = React.useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = React.useState(false);
  const [isTeamModalOpen, setIsTeamModalOpen] = React.useState(false);

  const handleRemove = () => setIsRemoveModalOpen(true);
  const handleCloseRemoveModal = () => setIsRemoveModalOpen(false);

  const dispatch = useDispatch();
  const userID = useSelector(selectUserId);
  const teamMembers = useSelector(selectTeamMembers) || [];
  const batchDialerList = useSelector(selectBatchDialerList);
  const integrationId = batchDialerList?.[0]?.id;


  const isConnected = Array.isArray(batchDialerList)
    ? batchDialerList.some(item => item.externalSystem === "BATCH_DIALER")
    : false;

  React.useEffect(() => {
    if (userID) {
      dispatch(getBatchDialerIntegration(userID));
    }
  }, [userID]);

  const handleConnect = () => {
    setShowPassword(false);
    setModalType("connect");
    setIsModalOpen(true);
  };

  const handleViewApiKey = () => {
    setModalType("view");
    setIsModalOpen(true);
  };

  const handleTeamPermission = () => {
    setIsTeamModalOpen(true);
    dispatch(getTeamMembers(userID));
  };

  const handleCloseTeamModal = () => {
    setIsTeamModalOpen(false);
  };


  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setShowCopyMsg(true);
    setTimeout(() => setShowCopyMsg(false), 2000);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
    setShowCopyMsg(false);
  };

  const menuItems = [
    { label: "View API Key", onClick: handleViewApiKey },
    ...(teamMembers.length > 0
      ? [{ label: "Team Permission", onClick: handleTeamPermission }]
      : []),
    { label: "Remove", onClick: handleRemove },
  ];

  return (
    <div className={classNames(css.clsCard, css.clsIntegrationCard)}>
      {/* Header */}
      <div
        className={classNames(
          css.clsCardHeader,
          css.d_flex,
          css.align_items_center,
          css.justify_content_between
        )}
      >
        <h4 className={classNames(css.clsCardTitle)}>Integrations</h4>

      </div>
      <div ref={ref} id="integrations" className={css.clsCardBody}>
        <div className={css.clsCardContainer}>
          <div className={css.logoCard}>
            <img src={BatchDialerlogo} alt="BatchDialer" />
            <span className={css.batchTxt}>BatchDialer</span>
            <div className={css.ticklogo}>
              <img src={isConnected ? greentick : tickdisable} alt={isConnected ? "connected" : "not connected"} />
            </div>
          </div>
          <div>
            {!isConnected ? (
              <button className={css.connectBtn} onClick={handleConnect}>
                <span className={css.errorBtnLabel}>Connect</span>
              </button>
            ) : (
              <>
                {/* // Menu Icon with Popover */}
                <div
                  className={classNames(css.menuIconWrapper, { [css.activeMenu]: isMenuOpen })}
                  onClick={() => setIsMenuOpen((prev) => !prev)}
                >
                  <img
                    src={isMenuOpen ? menuhover : menuicon}
                    alt="menu icon"
                    className={css.menuIcon}
                  />

                  <PopoverMenu
                    isOpen={isMenuOpen}
                    onClose={() => setIsMenuOpen(false)}
                    items={menuItems}
                    position="top-left"                  
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <BatchDialer
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        modalType={modalType}
        text={text}
        setText={setText}
        showPassword={showPassword}
        togglePasswordVisibility={togglePasswordVisibility}
        showCopyMsg={showCopyMsg}
        handleCopy={handleCopy}
        integrationId={integrationId}
      />
      <RemoveBatchDialer
        isOpen={isRemoveModalOpen}
        onClose={handleCloseRemoveModal}
        integrationId={integrationId}
      />
      <TeamsBatchDailer
        isOpen={isTeamModalOpen}
        onClose={handleCloseTeamModal}
        integrationId={integrationId}
      />
    </div >
  );
});

export default BatchDialerSection;
